import { useGlobals } from '@bwoty-web/ui-kit/hooks';
import cx from 'classnames';
import './logotype.scss';

const getLogoSrc = (siteId, baseUrl) => {
  switch (siteId) {
    case 1:
    case 3:
      return `${baseUrl}/static/images/logo-ving.svg`;
    case 11:
      return `${baseUrl}/static/images/logo-spies.svg`;
    case 15:
      return `${baseUrl}/static/images/logo-tjareborg.svg`;
    case 18:
      return `${baseUrl}/static/images/logo-globetrotter.svg`;
    case 145:
    case 146:
    case 147:
    case 148:
      return `${baseUrl}/static/images/logo-sunclass.svg`;
    case 152:
      return `${baseUrl}/static/images/logo-nltg.svg`;
    default:
      return null;
  }
};

const Logotype = () => {
  const { siteId, content, baseUrl } = useGlobals();
  const { logoAltText, headerTitle } = content || {};
  const logoSrc = getLogoSrc(siteId, baseUrl);

  return logoSrc ? (
    <a
      href="/"
      className={cx('header-logotype', {
        'header-logotype--nltg': siteId === 152,
      })}
    >
      <img alt={logoAltText || 'Logotype'} src={logoSrc} />
    </a>
  ) : (
    <a href="/" className="header-logotype header-logotype--text">
      {headerTitle}
    </a>
  );
};

export default Logotype;
